export default defineNuxtPlugin(async () => {
  const deviceId = useDeviceId();

  await deviceId.load();
});
